import { render, staticRenderFns } from "./policyServices.vue?vue&type=template&id=1d5cec5e&scoped=true&"
import script from "./policyServices.vue?vue&type=script&lang=js&"
export * from "./policyServices.vue?vue&type=script&lang=js&"
import style0 from "./policyServices.vue?vue&type=style&index=0&id=1d5cec5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5cec5e",
  null
  
)

export default component.exports